import { CourseHeatMapPresenter } from '@/presentation/presenters/dashboard/courseHeatMapPresenter'
import { CourseHeatMapViewModel } from '@/presentation/viewmodels/dashboard/courseHeatMapViewModel'

export function useCourseHeatMapPresenter(
  presenter: CourseHeatMapPresenter = new CourseHeatMapPresenter(new CourseHeatMapViewModel())
) {
  return {
    courseStatisticsList: presenter.courseStatisticsList,
    heatMapXLabel: presenter.heatMapXLabel,
    heatMapSeries: presenter.heatMapSeries,
    chartOptions: presenter.chartOptions,
    hasData: presenter.hasData,
    isPlotting: presenter.isPlotting,
    isLoading: presenter.isLoading,
    error: presenter.error,
    getCourseStatisticsListByLanguage: presenter.getCourseStatisticsListByLanguage.bind(presenter),
    plotHeatMap: presenter.plotHeatMap.bind(presenter),
    clickElement: presenter.clickElement.bind(presenter)
  }
}
